// 楽天市場 システム利用料 料率テーブル
// 累進課税方式: 各レンジの売上にそのレンジの料率をかけて合算

const planOptions = [
  { value: 'ganbare', label: 'がんばれ！プラン' },
  { value: 'standard', label: 'スタンダードプラン' },
  { value: 'mega', label: 'メガショッププラン' },
];

// 月商レンジ (上限値, 円)
const monthlySalesRanges = [
  { value: 500000, label: '〜50万円' },
  { value: 1000000, label: '〜100万円' },
  { value: 2000000, label: '〜200万円' },
  { value: 3000000, label: '〜300万円' },
  { value: 5000000, label: '〜500万円' },
  { value: 10000000, label: '〜1,000万円' },
  { value: 30000000, label: '〜3,000万円' },
  { value: 100000000, label: '〜1億円' },
  { value: 500000000, label: '〜5億円' },
  { value: Infinity, label: '5億円〜' },
];

// 平均バスケット単価レンジ (スタンダード/メガのみ)
const basketPriceRanges = [
  { value: 7000, label: '0〜7,000円' },
  { value: 15000, label: '7,000円〜1.5万円' },
  { value: 25000, label: '1.5〜2.5万円' },
  { value: 35000, label: '2.5〜3.5万円' },
  { value: 50000, label: '3.5〜5万円' },
  { value: Infinity, label: '5万円〜' },
];

// がんばれ！プラン: 月商レンジのみ (累進)
// tiers: [{ limit, pc, mobile }]  limit = そのレンジの上限
const ganbareTiers = [
  { limit: 500000, pc: 0.065, mobile: 0.070 },
  { limit: 1000000, pc: 0.060, mobile: 0.065 },
  { limit: 5000000, pc: 0.055, mobile: 0.060 },
  { limit: 10000000, pc: 0.045, mobile: 0.050 },
  { limit: Infinity, pc: 0.035, mobile: 0.040 },
];

// スタンダード/メガショップ: バスケット単価 × 月商レンジ (累進)
// ~100万は全バスケット単価で一律 (pc: 4.0%, mobile: 4.5%)
// tiers: [{ limit, pc, mobile }]
const standardMegaRatesByBasketPrice = {
  7000: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.030, mobile: 0.035 },
    { limit: 3000000, pc: 0.030, mobile: 0.035 },
    { limit: 5000000, pc: 0.028, mobile: 0.033 },
    { limit: 10000000, pc: 0.028, mobile: 0.033 },
    { limit: 30000000, pc: 0.026, mobile: 0.031 },
    { limit: Infinity, pc: 0.024, mobile: 0.029 },
  ],
  15000: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.030, mobile: 0.035 },
    { limit: 3000000, pc: 0.028, mobile: 0.033 },
    { limit: 5000000, pc: 0.028, mobile: 0.033 },
    { limit: 10000000, pc: 0.026, mobile: 0.031 },
    { limit: 30000000, pc: 0.024, mobile: 0.029 },
    { limit: Infinity, pc: 0.024, mobile: 0.029 },
  ],
  25000: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.028, mobile: 0.033 },
    { limit: 3000000, pc: 0.028, mobile: 0.033 },
    { limit: 5000000, pc: 0.026, mobile: 0.031 },
    { limit: 10000000, pc: 0.024, mobile: 0.029 },
    { limit: 30000000, pc: 0.024, mobile: 0.029 },
    { limit: Infinity, pc: 0.022, mobile: 0.027 },
  ],
  35000: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.028, mobile: 0.033 },
    { limit: 3000000, pc: 0.026, mobile: 0.031 },
    { limit: 5000000, pc: 0.024, mobile: 0.029 },
    { limit: 10000000, pc: 0.024, mobile: 0.029 },
    { limit: 30000000, pc: 0.022, mobile: 0.027 },
    { limit: Infinity, pc: 0.022, mobile: 0.027 },
  ],
  50000: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.026, mobile: 0.031 },
    { limit: 3000000, pc: 0.024, mobile: 0.029 },
    { limit: 5000000, pc: 0.024, mobile: 0.029 },
    { limit: 10000000, pc: 0.022, mobile: 0.027 },
    { limit: 30000000, pc: 0.022, mobile: 0.027 },
    { limit: Infinity, pc: 0.020, mobile: 0.025 },
  ],
  Infinity: [
    { limit: 1000000, pc: 0.040, mobile: 0.045 },
    { limit: 2000000, pc: 0.024, mobile: 0.029 },
    { limit: 3000000, pc: 0.024, mobile: 0.029 },
    { limit: 5000000, pc: 0.022, mobile: 0.027 },
    { limit: 10000000, pc: 0.022, mobile: 0.027 },
    { limit: 30000000, pc: 0.020, mobile: 0.025 },
    { limit: Infinity, pc: 0.020, mobile: 0.025 },
  ],
};

// 楽天ペイ（決済手数料）: バスケット単価 × 月間決済高 (累進想定)
// PC/モバイル区別なし、rate 1つ
const rakutenPayRatesByBasketPrice = {
  7000: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.034 },
    { limit: 3000000, rate: 0.034 },
    { limit: 5000000, rate: 0.033 },
    { limit: 10000000, rate: 0.033 },
    { limit: 30000000, rate: 0.032 },
    { limit: 100000000, rate: 0.032 },
    { limit: 500000000, rate: 0.030 },
    { limit: Infinity, rate: 0.029 },
  ],
  15000: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.034 },
    { limit: 3000000, rate: 0.033 },
    { limit: 5000000, rate: 0.033 },
    { limit: 10000000, rate: 0.032 },
    { limit: 30000000, rate: 0.032 },
    { limit: 100000000, rate: 0.030 },
    { limit: 500000000, rate: 0.029 },
    { limit: Infinity, rate: 0.028 },
  ],
  25000: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.033 },
    { limit: 3000000, rate: 0.033 },
    { limit: 5000000, rate: 0.032 },
    { limit: 10000000, rate: 0.032 },
    { limit: 30000000, rate: 0.030 },
    { limit: 100000000, rate: 0.029 },
    { limit: 500000000, rate: 0.028 },
    { limit: Infinity, rate: 0.027 },
  ],
  35000: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.033 },
    { limit: 3000000, rate: 0.032 },
    { limit: 5000000, rate: 0.032 },
    { limit: 10000000, rate: 0.030 },
    { limit: 30000000, rate: 0.029 },
    { limit: 100000000, rate: 0.028 },
    { limit: 500000000, rate: 0.027 },
    { limit: Infinity, rate: 0.026 },
  ],
  50000: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.032 },
    { limit: 3000000, rate: 0.032 },
    { limit: 5000000, rate: 0.030 },
    { limit: 10000000, rate: 0.029 },
    { limit: 30000000, rate: 0.028 },
    { limit: 100000000, rate: 0.027 },
    { limit: 500000000, rate: 0.026 },
    { limit: Infinity, rate: 0.025 },
  ],
  Infinity: [
    { limit: 1000000, rate: 0.035 },
    { limit: 2000000, rate: 0.032 },
    { limit: 3000000, rate: 0.030 },
    { limit: 5000000, rate: 0.029 },
    { limit: 10000000, rate: 0.028 },
    { limit: 30000000, rate: 0.027 },
    { limit: 100000000, rate: 0.026 },
    { limit: 500000000, rate: 0.025 },
    { limit: Infinity, rate: 0.025 },
  ],
};

// 累進計算: 売上高から手数料を算出
const computeProgressiveFee = (sales, tiers, channel) => {
  let remaining = sales;
  let prev = 0;
  return tiers.reduce((x, tier) => {
    if (remaining <= 0) return x;
    const rangeSize = tier.limit === Infinity ? remaining : tier.limit - prev;
    const taxable = Math.min(remaining, rangeSize);
    prev = tier.limit;
    remaining -= taxable;
    return x + taxable * tier[channel];
  }, 0);
};

// プラン・バスケット単価からティアを取得
const getTiers = (plan, basketPriceRange) => {
  if (plan === 'ganbare') return ganbareTiers;
  const key = basketPriceRanges.find(_ => _.value >= basketPriceRange)?.value || Infinity;
  return standardMegaRatesByBasketPrice[key] || standardMegaRatesByBasketPrice[Infinity];
};

// 楽天ペイのティアを取得
const getRakutenPayTiers = (basketPriceRange) => {
  const key = basketPriceRanges.find(_ => _.value >= basketPriceRange)?.value || Infinity;
  return rakutenPayRatesByBasketPrice[key] || rakutenPayRatesByBasketPrice[Infinity];
};

// 実効料率を算出 (月商レンジの上限まで売上がある前提)
const computeEffectiveRate = (plan, monthlySalesRange, basketPriceRange) => {
  const tiers = getTiers(plan, basketPriceRange);
  const sales = monthlySalesRange === Infinity ? 1000000000 : monthlySalesRange;
  const pcFee = computeProgressiveFee(sales, tiers, 'pc');
  const mobileFee = computeProgressiveFee(sales, tiers, 'mobile');

  const payTiers = getRakutenPayTiers(basketPriceRange);
  const payFee = computeProgressiveFee(sales, payTiers, 'rate');

  return {
    pc: sales > 0 ? pcFee / sales : 0,
    mobile: sales > 0 ? mobileFee / sales : 0,
    pay: sales > 0 ? payFee / sales : 0,
  };
};

exports.planOptions = planOptions;
exports.monthlySalesRanges = monthlySalesRanges;
exports.basketPriceRanges = basketPriceRanges;
exports.ganbareTiers = ganbareTiers;
exports.standardMegaRatesByBasketPrice = standardMegaRatesByBasketPrice;
exports.rakutenPayRatesByBasketPrice = rakutenPayRatesByBasketPrice;
exports.computeProgressiveFee = computeProgressiveFee;
exports.getTiers = getTiers;
exports.getRakutenPayTiers = getRakutenPayTiers;
exports.computeEffectiveRate = computeEffectiveRate;
